import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_TICKET_POSTPONE_PROCESS,
  CLEAR_TICKET_POSTPONE_PROCESSES,
  FLAG_GETTING_TICKET_POSTPONE_PROCESSES,
  FLAG_TICKET_POSTPONE_PROCESS_ACTIVITY,
  GET_TICKET_POSTPONE_PROCESS,
  GET_TICKET_POSTPONE_PROCESSES,
} from '../types';
import { TICKET_POSTPONE_PROCESS_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_GET_CONFIG } from '../../config/rest';

const flagTicketPostponeProcesses = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_TICKET_POSTPONE_PROCESSES,
    payload: flag,
  });

const getTicketPostponeProcesses = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagTicketPostponeProcesses(true));
    const query = tableFilters;
    const url = `${TICKET_POSTPONE_PROCESS_ENDPOINT}?${QueryString.stringify(
      query,
    )}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();
    dispatch({
      type: GET_TICKET_POSTPONE_PROCESSES,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagTicketPostponeProcesses(false));
  }
};

const clearTicketPostponeProcesses = () => (dispatch) =>
  dispatch({
    type: CLEAR_TICKET_POSTPONE_PROCESSES,
  });

const flagTicketPostponeProcessActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_TICKET_POSTPONE_PROCESS_ACTIVITY,
    payload: flag,
  });

const getTicketPostponeProcess =
  async ({ ticketPostponeProcessId }) =>
  async (dispatch) => {
    try {
      dispatch(flagTicketPostponeProcessActivity(true));
      const url = `${TICKET_POSTPONE_PROCESS_ENDPOINT}/${ticketPostponeProcessId}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();
      dispatch({
        type: GET_TICKET_POSTPONE_PROCESS,

        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagTicketPostponeProcessActivity(false));
    }
  };

const clearTicketPostponeProcess = () => (dispatch) =>
  dispatch({
    type: CLEAR_TICKET_POSTPONE_PROCESS,
  });

export {
  getTicketPostponeProcesses,
  clearTicketPostponeProcesses,
  getTicketPostponeProcess,
  clearTicketPostponeProcess,
};
